import { map } from "lodash-es";

type AsyncCallback<T, K> = (item: T, index: number, collection: T[]) => K;

export const asyncEach = async <T, K>(collection: T[], callback: AsyncCallback<T, K>) => {
  return await Promise.all(map(collection, callback));
};

export default asyncEach;
